export const BOARD_THEMES = {
    blue: {
      dark: {
        background: "linear-gradient(to left, #3066BE, #4A7DD9)"
      },
      light: {
        background: "linear-gradient(to left, #fffff0, #f5e4c3)"
      },
    },
    brown: {

      dark: {
        background: "#b58863"
      },
      light: {
        background: "#f0d9b5"
      },
// Probably not needed for each of them... Stick to one default gold, in the local file.
      
    },
    green: {
      dark: {
        background: "linear-gradient(to left, #2E7D32, #43A047)"
      },
      light: {
        background: "linear-gradient(to left, #fffff0, #f5e4c3)"
      },

    },
    pink: {
      dark: {
        background: "#ea628b"
      },
      light: {
        background: "linear-gradient(to left, #fffff0, #f5e4c3)"
      },

    },

    
    // This is a placeholder for the custom theme
    // The actual custom colors are handled in the Settings component
    custom: {
      dark: {
        background: "linear-gradient(to left, #3066BE, #4A7DD9)"
      },
      light: {
        background: "linear-gradient(to left, #fffff0, #f5e4c3)"
      },
      moveFrom: {
        background: "rgba(255, 0, 80, 0.5)"
      },
      moveTo: {
        background: "rgba(255, 0, 80, 0.5)"
      }
    }
    
  };

// Default move highlight colors if not specified in theme, some duplicate issue in Board.jsx that causes it to render different on AddGame vs. ViewGame, however, they are both set to gold
export const DEFAULT_MOVE_HIGHLIGHT = {
  moveFrom: { backgroundColor: 'rgba(255, 215, 0, 0.75)' },
  moveTo: { backgroundColor: 'rgba(255, 215, 0, 0.75)' }
};

export default BOARD_THEMES;